<template>
    <MainContent>
        <template v-slot:header>
            <PageTitle title="Detalles de la ficha"/>
        </template>

        <template v-slot:content>
            <b-row v-if="!loading && base">
                <b-col cols="12">
                    <b-list-group>
                        <DatosNino :base="base" :fields="fields"/>
                    </b-list-group>
                </b-col>
                
                <b-col cols="12">
                    <b-card no-body>
                        <b-tabs card @input="setActive">
                            <b-tab title="Datos personales" :active="active == 'datospersonales'">
                                <DatosPersonales :base="base" @getBase="getBase(), setActive('datospersonales')" :url="url_documentacion" :params="params"/>
                            </b-tab>
                            <b-tab title="Datos deportivos" :active="active == 'deportivos'">
                                <DatosDeportivos :base="base" @getBase="getBase(), setActive('deportivos')"/>
                            </b-tab>
                            <b-tab title="Lesiones" :active="active == 'lesiones'">
                                <Lesiones v-if="active === 2" :base_id="base.id"/>
                            </b-tab>
                            <b-tab title="Sanciones" :active="active == 'sanciones'">
                                <Sanciones v-if="active === 3" :base_id="base.id" :base="base"/>
                            </b-tab>
                            <b-tab title="Transacciones" :active="active == 'transacciones'">
                                <Transacciones :transacciones="base.transacciones" :params="params" :ruta="'back.bases.transacciones.editar'" @actualizar="getBase(), setActive('transacciones')"/>
                            </b-tab>
                            <b-tab title="Indumentarias" :active="active == 'indumentarias'">
                                <Indumentarias
                                    v-if="base.indumentarias"
                                    :indumentarias="base.indumentarias" 
                                    @actualizar="getBase(), setActive('indumentarias')"
                                    :nombre="base.camiseta_nombre"
                                    :numero="base.camiseta_numero"
                                />
                                <div v-else class="alert alert-warning mb-0" role="alert">
                                    Este deportista no ha adquirido ninguna indumentaria.
                                </div>
                            </b-tab>
                            <b-tab title="Plazos" :active="active == 'plazos'">
                                <Plazos :plazos="base.plazos" :data="base" :params="params" url_generar_enlace="back.bases.plazos.enviar-url-compra" @pagar-plazo="pagarPlazo" @pagar-plazos="pagarPlazos" @descontar-plazo="descontarPlazo"/>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-col>
            </b-row>
            <LoaderComponent v-else/>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import PageTitle from '@/components/backend/components/PageTitleComponent';
    import DatosNino from '@/components/backend/bases/components/DatosNino';
    import DatosPersonales from '@/components/backend/bases/components/DatosPersonales.vue';
    import DatosDeportivos from '@/components/backend/bases/components/DatosDeportivos.vue';
    import Lesiones from '@/components/backend/bases/components/Lesiones.vue';
    import Sanciones from '@/components/backend/bases/components/Sanciones';
    import Transacciones from '@/components/backend/components/transacciones/Transacciones';
    import Indumentarias from '@/components/backend/bases/components/Indumentarias';
    import Plazos from '@/components/backend/components/plazos/Plazos';

    export default {
        name: "DetalleBase",
        data() {
            return {
                base: null,
                fields: [],
                params: {
                    base_id: this.$route.params.base_id
                },
                loading: false,
                url_documentacion: null,
                active: '',
                lista_id: this.$route.params.lista_id
            }
        },
        created() {
            this.getBase();
            this.getFields();
        },
        methods: {
            getBase() {
                this.loading = true;

                const params = this.params;
                params.lista_id = this.lista_id;
                params.filters = {
                    teatro_id: this.teatro.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.bases.show'), params).then(res => {
                    this.base = res.data.data;
                    this.url_documentacion = this.config.API_BASE + "/f/upload/documento?tipo=bases&base_id=" + this.params.base_id + "&id=" + this.base.dni;
                    this.loading = false;
                });
            },
            getFields() {
                this.loading = true;

                const params = this.params;
                params.lista_id = this.lista_id;
                params.filters = {
                    teatro_id: this.teatro.id
                }

                this.$store.dispatch(this.config.getVuexAlias("back.bases.fields"), params).then(res => {
                    this.fields = res.data.data;
                }).catch(e => {
                    this.$toast.error(e.response.data.message);
                });
                this.loading = false;
            },
            setActive(data) {
                this.active = data;
            },
            pagarPlazo(metodo_pago, plazo_id) {
                let parametros = this.params;

                parametros.lista_id = this.lista_id;
                parametros.plazo_id = plazo_id;
                parametros.filters = {
                    tid: this.configuracion.hash_teatro,
                    metodo_pago: metodo_pago
                }

                this.$store.dispatch(this.config.getVuexAlias('back.bases.plazos.pagar'), parametros).then(res => {
                    this.$toast.success(res.data.message);
                    this.getBase();
                    this.setActive('plazos');
                    this.close();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
            },
            pagarPlazos(metodo_pago) {
                let parametros = this.params;

                parametros.lista_id = this.lista_id;
                parametros.filters = {
                    tid: this.configuracion.hash_teatro,
                    metodo_pago: metodo_pago
                }

                this.$store.dispatch(this.config.getVuexAlias('back.bases.plazos.pagar-todos'), parametros).then(res => {
                    this.$toast.success(res.data.message);
                    this.getBase();
                    this.setActive('plazos');
                    this.close();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
            },
            descontarPlazo(descuento_integro, descuento_porcentaje, plazo_id) {
                let parametros = this.params;

                parametros.lista_id = this.lista_id;
                parametros.plazo_id = plazo_id;
                parametros.filters = {
                    tid: this.configuracion.hash_teatro,
                    descuento_integro: descuento_integro,
                    descuento_porcentaje: descuento_porcentaje
                }

                this.$store.dispatch(this.config.getVuexAlias('back.bases.plazos.descontar'), parametros).then(res => {
                    this.$toast.success(res.data.message);
                    this.getBase();
                    this.setActive('plazos');
                }).catch(e => {
                    this.$toast.error(e.response.data.message ? e.response.data.message : 'Error al intentar aplicar un descuento');
                });
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            MainContent, PageTitle, DatosNino, DatosPersonales, DatosDeportivos, Lesiones, Sanciones, Transacciones, Indumentarias, Plazos
        }
    }
</script>
